import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {ToolsService} from "../../services/toolsService/tools.service";
import {Item} from "../../models/Item";
import {UiAdapterService} from "../../services/uiAdapterService/ui-adapter.service";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'app-search-result-container',
  templateUrl: './search-result-container.component.html',
  styleUrls: ['./search-result-container.component.scss']
})
export class SearchResultContainerComponent implements OnInit {

  private _searchText:string;
  private items:any;
  private tools:any;
  public resultItems:any[];
  public resultTools:any[];
  public Yiit = Yiit;

  get searchText(){
    return this._searchText;
  }

  @Input() set searchText(val){
    this._searchText = val;
    this.updateResultList();
  }

  @Output() updateCurrentTool: EventEmitter<any> = new EventEmitter<any>();


  constructor(private im: ItemManagerService, private toolAdapter: ToolsService, private cd: ChangeDetectorRef, private ui: UiAdapterService) { }

  ngOnInit() {
    this.tools = this.toolAdapter.flatToolList;
    this.im.itemsList.pipe(debounceTime(1000)).subscribe((list)=>{
      this.items = list;
      this.updateResultList();
    });
  }

  updateResultList(){
    if (this.searchText && this.items){
      console.log(Object.values(this.items));
      this.resultItems = Object.values(this.items).filter((item:Item)=>{return item.config.getTitle().toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0});
      this.resultTools = Object.values(this.tools).filter((tool:any)=>{return tool.name.toLowerCase().indexOf(this.searchText.toLowerCase()) >= 0});
      this.cd.detectChanges();
    }
  }

  getItemImg(item){
    // @ts-ignore
    return item.config.getObjectConfig().getMapIcon() || item.config.getTool().menu_icon || null;
  }

  getMenuIcon(tool) {
    if (tool.category && tool.category.menu_icon && tool.category.menu_icon > 0){
      return tool.category.menu_icon;
    }
    if(tool.menu_icon && tool.menu_icon.length > 0){
      return tool.menu_icon;
    }
    return null;
  };

  getHint(item) {
    return ((item.hint && item.hint.length) ? item.hint : '');
  }

  _updateCurrentTool(tool, event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.updateCurrentTool.emit(tool);
  }

  selectItem(item){
    item.centerOnObj();
    item.onSelect();
    this.ui.selectedItem$ = item;
  }
}
